import React from 'react'
import GeneralNotifModal from '../GeneralModal/generalNotifModal'
import userIcn from '../../assets/ic-user.svg'
import styles from './EndStreamModal.module.css'

const EndStreamModal = ({ message = {}, open, dismiss = () => {} }) => {
  const { profile, data } = message || {}
  return <GeneralNotifModal open={open}>
    <div className={styles.wrapper}>
      {profile && 
        <>
          <div className={styles.title}>
            <img src={(profile.avatar) ? profile.avatar : userIcn} alt="profile page" />
            <span>{profile.name}</span>
          </div>
          <div className={styles.subtitle}>
            { data }
          </div>
        </>
      }
      <div className={styles.action}>
        <span onClick={() => dismiss()}>Got it</span>
      </div>
    </div>
  </GeneralNotifModal>
}

export default EndStreamModal;

